import React, { Component } from "react";
import { Link } from "react-router-dom";
import data from "../Data/data.js";
export default class ShowWork extends Component {
  renderWorkList() {
    const modifiedData = data.slice(0, data.length);
    const renderElement = modifiedData.map(element => {
      return (
        <li className="work_figure" key={element.index}>
          <figure
            onMouseEnter={() => this.props.runOnEnter()}
            onMouseLeave={() => {
              this.props.runOnLeave();
            }}
          >
            <img src={element.thumbnail} alt={element.title} />
            <figcaption className="imageDetails">
              <h2>{element.title}</h2>
              <p>{element.description}</p>
              <Link to={`/work/${element.index}`}>More</Link>
            </figcaption>
          </figure>
        </li>
      );
    });
    return renderElement;
  }
  render() {
    return (
      <section className="show_work">
        <ul className="work_snapshot">
          <li className="work_figure">
            <figure
              onMouseEnter={() => this.props.runOnEnter()}
              onMouseLeave={() => {
                this.props.runOnLeave();
              }}
            >
              <img src="./images/SnakeGame4.png" alt="" />
              <figcaption className="imageDetails">
                <h2>Title</h2>
                <p>{data.length}</p>
                <a href="">More</a>
              </figcaption>
            </figure>
          </li>
          {this.renderWorkList()}
        </ul>
      </section>
    );
  }
}
